import React from 'react';
import styles from './DescribeSection.module.css';
import image from './images/signup.png';
import {
    OptimizedMotionH1,
    OptimizedMotionP,
} from '../../../shared/ui/optimized-motion/OptimizedMotion';

const DescribeSection: React.FC = () => {
    return (
        <div className={styles.container}>
            <img src={image} alt="describe" className={styles.image} />
            <div>
                <OptimizedMotionH1 className={styles.title} type="slide-down" delay={0.2}>
                    One‑Click Sign‑Off
                </OptimizedMotionH1>
                <OptimizedMotionP className={styles.description} type="slide-down" delay={0.4}>
                    Approvers annotate, accept, or request changes without downloading a file or
                    hunting for an email. Digital signatures and hand‑off timestamps lock when all
                    checks pass, triggering automatic publishing or the next workflow stage.
                </OptimizedMotionP>
            </div>
            <div className={styles.blur}></div>
        </div>
    );
};

export default DescribeSection;
